import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "ylp_cookie_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setShow(true), 1200);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setShow(false);
  };
  const decline = () => {
    localStorage.setItem(KEY, "declined");
    setShow(false);
  };

  if (!show) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:right-auto md:max-w-md z-[55] safe-bottom"
    >
      <div className="rounded-2xl border border-[#1E2F44] bg-[#0D1B2A]/95 backdrop-blur-xl p-4 md:p-5 shadow-2xl shadow-black/40">
        <div className="flex items-start gap-3">
          <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#22D3EE]/10 text-[#22D3EE] border border-[#22D3EE]/30">
            <Cookie className="h-4 w-4" />
          </span>
          <div className="flex-1">
            <div className="font-display text-sm font-semibold">Käytämme vain välttämättömiä evästeitä</div>
            <p className="mt-1 text-xs text-neutral-400 leading-relaxed">
              Sivusto käyttää välttämättömiä evästeitä sivun toiminnan takaamiseksi. Emme
              seuraa sinua kolmansien osapuolten työkaluilla. Lue lisää{" "}
              <Link to="/tietosuoja" className="text-[#22D3EE] hover:text-[#67E8F9] underline">
                tietosuojaselosteesta
              </Link>
              .
            </p>
            <div className="mt-3 flex items-center gap-2">
              <button
                onClick={accept}
                data-testid="cookie-accept"
                className="inline-flex items-center gap-1 rounded-md bg-[#22D3EE] px-4 py-2 text-xs font-semibold text-[#07111F] hover:bg-[#67E8F9] transition-all"
              >
                Selvä
              </button>
              <button
                onClick={decline}
                data-testid="cookie-decline"
                className="inline-flex items-center gap-1 rounded-md border border-[#1E2F44] bg-transparent px-4 py-2 text-xs font-medium text-neutral-300 hover:bg-white/5 transition-all"
              >
                Ei kiitos
              </button>
            </div>
          </div>
          <button
            onClick={decline}
            aria-label="Sulje"
            className="text-neutral-500 hover:text-white"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
